function e(){return t}const t=e=>e;export{e as identity};
//# sourceMappingURL=identity-CdMenAq7.js.map